import { AllowedReducer } from '@leverege/api-redux';
import { AbstractGroupDelegate } from '@leverege/molten/data-source';
import { RoutesUtil } from '@leverege/molten/routes';
import { GlobalState } from '@leverege/ui-redux';
import FotaApi from "../api/FotaApi.js";
import FotaReducer from "../reducer/FotaReducer.js";
export default class AbstractFotaGroupDelegate extends AbstractGroupDelegate {
  constructor(options) {
    super(options);
    this.options = options;
    const {
      match,
      relationship
    } = options;
    this.match = match;
    this.relationship = relationship;
    this.api = new FotaApi({
      relationship
    });
  }
  getApi() {
    console.warn('AbstractFotaGroupDelegate.getApi: unimplemented');
  }
  item(id) {
    const iRel = this.relationship.createItem(this.match, id);
    const Clazz = this.itemDelegateClass;
    return new Clazz({
      match: iRel.match,
      relationship: iRel,
      id
    });
  }
  requestCanList(opts) {
    return this.getApi().canList({
      query: opts
    });
  }
  list(opts, extra) {
    return this.getApi().list({
      query: opts
    }, extra);
  }
  requestCanSearch(opts) {
    return this.getApi().canList({
      query: opts
    });
  }
  search(opts, extra) {
    return this.getApi().list({
      query: opts
    }, extra);
  }
  getInterfaceUrl() {
    return this.relationship.ref;
  }
  getUrl() {
    return RoutesUtil.resolve(this.relationship.urlPath, this.match);
  }
  getResourceId(forFotaReducer, opts) {
    const path = this.relationship.refPath.slice(1);
    return forFotaReducer ? `${path}$${opts?.queryName || 'default'}` : path;
  }
  requestCanGet(id) {
    return this.item(id).requestCanGet();
  }
  get(id, opts, extra) {
    return this.item(id).get(opts, extra);
  }
  requestCanCreate(obj, options) {
    return this.getApi().canCreate(obj, options);
  }
  create(obj, options, extra) {
    return this.getApi().create(obj, {
      query: options
    }, extra);
  }
  requestCanUpdate(id, patch, options) {
    return this.item(id).requestCanUpdate(patch, options);
  }
  update(id, patch, options, extra) {
    return this.item(id).update(patch, {
      query: options
    }, extra);
  }
  requestCanDelete(id, deleteBody, options) {
    return this.item(id).requestCanDelete(deleteBody, options);
  }
  delete(id, deleteBody, options, extra) {
    return this.item(id).delete(deleteBody, options, extra);
  }

  // utility

  goTo(id) {
    return this.item(id).goTo();
  }
  isGotoAllowed() {
    return true;
  }

  // access

  canList(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.list;
  }
  getList(state = GlobalState.get(), opts) {
    return FotaReducer.get(state, this.getResourceId(true, opts));
  }
  getItem(id, state = GlobalState.get(), opts) {
    return this.item(id).getItem(state, opts);
  }
  getImagineGroup(id) {
    return this.item(id).getImagineGroup();
  }
  getImagineGroupItem(state = GlobalState.get(), id) {
    return this.item(id).getImagineGroupItem(state);
  }
  isLoading(state = GlobalState.get(), opts) {
    return FotaReducer.getStatus(state, this.getResourceId(true, opts)) === FotaReducer.LOADING;
  }
  isDone(state = GlobalState.get(), opts) {
    return FotaReducer.getStatus(state, this.getResourceId(true, opts)) !== FotaReducer.LOADING;
  }
  canUpdate(id, state = GlobalState.get()) {
    return this.item(id).canUpdate(state);
  }
  canDelete(id, state = GlobalState.get()) {
    return this.item(id).canDelete(state);
  }
  canGet(id, state = GlobalState.get()) {
    return this.item(id).canGet(state);
  }
  canCreate(state = GlobalState.get()) {
    return AllowedReducer.get(state, this.getResourceId())?.create;
  }
}